export const model = {
    id: null,
    name: '',
    code: '',
    is_service: false,
    letterhead: false,
    parent_id: "",
    price: "",
    discount_price: "",
    is_secondary: false,
    secondary_price: "",
    secondary_resident_price: "",
    category_id: "",
    unnecessary_enclosure: false,
    for_outsource: false,
    enabled: true,
    auto_write_off: false,
    items: [],
    write_off_notify: true,
    created_at: '',
    updated_at: '',
    is_phy: false
};
